import en from './en.json'

export const defaultLocale = 'en'

export const languages = {
  en: en
}
